import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { Toaster } from "sonner";
import { SiteProvider } from "@/context/SiteContext";
import { AuthProvider } from "@/context/AuthContext";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import Galleries from "@/pages/Galleries";
import GalleryDetail from "@/pages/GalleryDetail";
import Articles from "@/pages/Articles";
import ArticleDetail from "@/pages/ArticleDetail";
import PageView from "@/pages/PageView";
import Contact from "@/pages/Contact";
import Admin from "@/pages/Admin";
import AuthCallback from "@/pages/AuthCallback";
import Locations from "@/pages/Locations";
import LocationDetail from "@/pages/LocationDetail";
import Events from "@/pages/Events";
import NotFound from "@/pages/NotFound";

function ScrollTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <Routes>
      <Route path="/admin" element={<Admin />} />
      <Route element={<Layout />}>
        <Route path="/" element={<Home />} />
        <Route path="/galleries" element={<Galleries />} />
        <Route path="/galleries/:slug" element={<GalleryDetail />} />
        <Route path="/articles" element={<Articles />} />
        <Route path="/articles/:slug" element={<ArticleDetail />} />
        <Route path="/locations" element={<Locations />} />
        <Route path="/locations/:slug" element={<LocationDetail />} />
        <Route path="/events" element={<Events />} />
        <Route path="/about" element={<PageView slug="about" />} />
        <Route path="/legal" element={<PageView slug="legal" />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="*" element={<NotFound />} />
      </Route>
    </Routes>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <SiteProvider>
          <ScrollTop />
          <AppRouter />
          <Toaster position="bottom-right" richColors />
        </SiteProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}
